export function capitalize(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  const firstLetter = value.charAt(0);
  const restLetters = value.substring(1, value.length);
  return firstLetter.toUpperCase() + restLetters;
}

export function getCount(count: number): string {
  if (count.toString().length === 1) {
    return `0${count}`;
  }
  return `${count}`;
}
